import { Link } from '@tanstack/react-router';
import { ArrowRight, Database, LayoutTemplate } from 'lucide-react';

import {
    ArtifactEvidence,
    ArtifactFrame,
    ArtifactLifecycleStatusBadge,
} from '@apps/web/routes/_app/admin/agent/artifacts/frame';
import {
    type AdminArtifactRendererProps,
    booleanValue,
    numberValue,
    scalarString,
    toRecord,
} from '@apps/web/routes/_app/admin/agent/artifacts/shared';

export function AdminDashboardPageArtifact({
    artifact,
}: AdminArtifactRendererProps) {
    const payload = toRecord(artifact.payload);
    const slug = scalarString(payload['slug']);
    const version = numberValue(payload['version']);
    const snapshotSequence = numberValue(payload['snapshot_sequence']);
    const active = booleanValue(payload['active']);

    return (
        <ArtifactFrame
            artifact={artifact}
            status={
                <ArtifactLifecycleStatusBadge
                    lifecycleStatus={artifact.lifecycle_status}
                />
            }
        >
            <div className="grid grid-cols-2 gap-2 text-xs">
                <div className="bg-muted/40 rounded-md p-2.5">
                    <span className="text-muted-foreground flex items-center gap-1">
                        <LayoutTemplate className="size-3.5" />
                        Presentation
                    </span>
                    <p className="text-foreground mt-1 font-medium">
                        {version === null ? 'Unknown' : `Version ${version}`}
                    </p>
                </div>
                <div className="bg-muted/40 rounded-md p-2.5">
                    <span className="text-muted-foreground flex items-center gap-1">
                        <Database className="size-3.5" />
                        Data
                    </span>
                    <p className="text-foreground mt-1 font-medium">
                        {snapshotSequence === null
                            ? 'Unknown'
                            : `Snapshot ${snapshotSequence}`}
                    </p>
                </div>
            </div>
            <div className="flex items-center justify-between gap-3">
                <span className="text-muted-foreground text-xs">
                    {active ? 'Published' : 'Draft — activation required'}
                </span>
                {slug ? (
                    <Link
                        to="/admin/agent/pages/$slug"
                        params={{ slug }}
                        className="text-foreground inline-flex items-center gap-1 text-xs font-medium hover:underline"
                    >
                        Open page
                        <ArrowRight className="size-3.5" />
                    </Link>
                ) : null}
            </div>
            <ArtifactEvidence artifact={artifact} />
        </ArtifactFrame>
    );
}
